import React from 'react';
import { FiActivity } from 'react-icons/fi';
import { useThemeClasses } from '../../hooks/useThemeClasses';
import AdminEmpty from './AdminEmpty';
import { formatAdminActionLabel, adminTimeAgo } from './adminFormat';

export default function AdminActivityList({
  activities = [],
  loading = false,
  emptyTitle = 'No hay actividad reciente',
  emptySubtitle = 'Los cambios de plataforma van a aparecer acá.',
  page = 1,
  pageSize = 12,
  onPageChange,
}) {
  const tc = useThemeClasses();
  const totalPages = Math.max(1, Math.ceil(activities.length / pageSize));
  const slice = activities.slice((page - 1) * pageSize, page * pageSize);

  if (loading) {
    return <p className={`text-xs ${tc.textMuted}`}>Cargando actividad…</p>;
  }

  if (!activities.length) {
    return <AdminEmpty icon={FiActivity} title={emptyTitle} subtitle={emptySubtitle} />;
  }

  return (
    <>
      <div className={`divide-y ${tc.modoOscuro ? 'divide-gray-800' : 'divide-gray-100'}`}>
        {slice.map((activity) => (
          <div
            key={activity.id || `${activity.createdAt}-${activity.action}`}
            className="py-3 flex items-start gap-3 text-xs first:pt-0"
          >
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 ${
                tc.modoOscuro ? 'bg-gray-800 text-gray-300' : 'bg-gray-100 text-gray-700'
              }`}
            >
              <FiActivity className="w-3.5 h-3.5" />
            </div>
            <div className="flex-1 min-w-0">
              <p className={`font-medium text-sm ${tc.textPri}`}>{formatAdminActionLabel(activity.action)}</p>
              {activity.details ? (
                <p className={`mt-0.5 line-clamp-2 ${tc.textSec}`}>{activity.details}</p>
              ) : null}
              <p className={`mt-1.5 ${tc.textMuted}`}>
                {activity.user || 'Sistema'} · {adminTimeAgo(activity.createdAt)}
                <span className="hidden sm:inline">
                  {' '}
                  · {new Date(activity.createdAt).toLocaleString('es-AR')}
                </span>
              </p>
            </div>
          </div>
        ))}
      </div>
      {activities.length > pageSize && onPageChange ? (
        <div className="mt-3 flex items-center justify-between text-[11px]">
          <span className={tc.textMuted}>
            {(page - 1) * pageSize + 1}–{Math.min(page * pageSize, activities.length)} de {activities.length}
          </span>
          <div className="flex items-center gap-1">
            <button
              type="button"
              onClick={() => onPageChange(Math.max(1, page - 1))}
              disabled={page === 1}
              className={`px-2 py-1 rounded border ${page === 1 ? 'opacity-40 cursor-not-allowed' : tc.btnOutline}`}
            >
              Anterior
            </button>
            <button
              type="button"
              onClick={() => onPageChange(Math.min(totalPages, page + 1))}
              disabled={page === totalPages}
              className={`px-2 py-1 rounded border ${page === totalPages ? 'opacity-40 cursor-not-allowed' : tc.btnOutline}`}
            >
              Siguiente
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
}
